import { useMachinesPortalStore } from 'components/sections/admin-portal/machines/store/use-machines-portal-store';
import useLatest from 'hooks/useLatestRef';
import { useEffect } from 'react';
import { createSocket, destroySocket } from 'services/socket';
import { useAuthStore } from 'stores/use-auth-store';

export function useSocket() {
  const current = useAuthStore((s) => s.current);

  const subscribed = useMachinesPortalStore((s) => s.subscribed);
  const restartSubscription = useMachinesPortalStore(
    (s) => s.restartSubscription
  );

  const latestSubscribed = useLatest(subscribed);

  useEffect(() => {
    if (!current.token) {
      // do not create the connection yet
      return;
    }

    const socket = createSocket(current.token);

    const onConnect = () => {
      useAuthStore.getState().setWsConnected(true);

      if (latestSubscribed.current) {
        // attempt to restart the subscription (e.g. if it was active at time of token rotation)
        restartSubscription();
      }
    };

    const onDisconnect = () => useAuthStore.getState().setWsConnected(false);

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      destroySocket();
    };
  }, [current.token]);

  return null;
}
